"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formattedDateShortWithYear = exports.formattedDateShort = exports.months = void 0;
var fp_1 = require("date-fns/fp");
exports.months = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
];
var dateFormatShort = 'MMM d';
var dateFormatShortWithYear = 'MMM d, yyyy';
var formattedDateShort = function (date) {
    return (0, fp_1.format)(dateFormatShort, date);
};
exports.formattedDateShort = formattedDateShort;
var formattedDateShortWithYear = function (date) {
    return (0, fp_1.format)(dateFormatShortWithYear, date);
};
exports.formattedDateShortWithYear = formattedDateShortWithYear;
//# sourceMappingURL=timeFormat.js.map